import { get, put, post, del } from "../api_helper2"
import { spreadSearchQuery } from "helpers/utilities"

const BASE_API_URL = `${process.env.REACT_APP_LABORATORY_ENDPOINT}/configurations/rules`

// TESTS CONFIG
// Get All Tests Config Method
const getAllTestRuleBased = (payload) => {
    let q = spreadSearchQuery(payload)
    return get(`${BASE_API_URL}?${q}`)
}

// Get Test Config By Id Method
const getTestRuleBasedByDetail = ({ id }) => {
    return get(`${BASE_API_URL}/${id}`)
}

// Delete Test Config By Id Method
const deleteTestRuleBasedByIds = params => {
    let ids = ""
    params.forEach(_param => (ids += `id=${_param.id}&`))

    return del(`${BASE_API_URL}?${ids}`)
}

// Update Test Config By Id Method
const updateTestRuleBasedById = (req) => {
    const { id } = req
    return put(`${BASE_API_URL}/${id}`, req)
}

// Create Test Config By Id Method
const createTestRuleBased = (req, testid) => {
    return post(`${BASE_API_URL}/`, req)
}

export { getAllTestRuleBased, getTestRuleBasedByDetail, deleteTestRuleBasedByIds, updateTestRuleBasedById, createTestRuleBased }
